import { TemplatePage } from './types';

const websiteVideoPage: TemplatePage = {
  header: {
    color: '#FECCD8',
    icon: 'images/video-templates/website.jpg',
    title: 'Free and Editable Website Video Templates',
    title_meta: 'Free and Editable Website Video Templates',
    description_meta:
      'Build amazing responsive web pages featuring great videos. Create clips from dozens of customizable website ' +
      'video templates.',
    description:
      'Make your website a spectacular place with a collection of website video templates. Leverage the responsive ' +
      'web design and build alluring web pages with Bootstrap, WordPress, and other frameworks.'
  },
  footer: {
    category: 'Website',
    description:
      'Wave.video helps you speed up the production of video content for your website, blog, and social media ' +
      'channels. Explore the rich collection of video templates and turn the ones you like into your own branded ' +
      'content. All elements of the templates are fully customizable. You can fine-tune them to your use case, message ' +
      'and branding in a matter of minutes.'
  },
  content: [
    {
      type: 'templates',
      title: 'website',
      search: { name: 'website' }
    },
    {
      type: 'stocks',
      title: 'website',
      search: { name: 'website' }
    },
    { type: 'calendar' }
  ]
};

export default websiteVideoPage;
